// extracted by mini-css-extract-plugin
export default {"main":"TeachersMentors_main__z+-6U","blocks":"TeachersMentors_blocks__B9Leq"};